<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  font-family: "Times New Roman", "serif";
}
a, button, [router-link] {
  outline: none !important;
  -webkit-tap-highlight-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue